import { gql } from "apollo-boost"

export const mutateInvoiceMonth = gql`
  mutation UpsertInvoiceMonth($data: InvoiceMonthInput!){
    InvoiceMonth(data: $data)
  }
`
